import { MatDialogRef } from '@angular/material/dialog';

export class DialogHelpers {
  static HIDDEN_DIALOG = 'hidden-dialog';
  static moveDialog<T, R>(dialogRef: MatDialogRef<T, R>, x: number, y: number): void {
    dialogRef.afterOpened().subscribe(() => {
      const el = document.getElementById(dialogRef.id!);

      const rect = el.getBoundingClientRect();
      const dialogWidth = rect.width;

      dialogRef.updatePosition({
        top: `${y}px`,
        left: `${x - dialogWidth}px`
      });

      dialogRef.removePanelClass(DialogHelpers.HIDDEN_DIALOG);
    });
  }
}
